import NewsletterForm from "./NewsletterForm";

const Footer = () => {
  return (
    <footer 
      className="border-t border-slate-200 bg-white mt-20"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        {/* Newsletter */}
        <div className="mb-12">
          <NewsletterForm />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold text-slate-900 mb-4">FinaNews</h3>
            <p className="text-sm text-slate-600">
              Blog de notícias sobre finanças pessoais com atualizações diárias automáticas.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-slate-900 mb-4">Categorias</h3>
            <ul className="space-y-2 text-sm text-slate-600">
              <li>Economia</li>
              <li>Investimentos</li>
              <li>Criptomoedas</li>
              <li>Mercados</li>
              <li>Negócios</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-slate-900 mb-4">Fontes</h3>
            <p className="text-sm text-slate-600 mb-2">
              Nosso conteúdo é agregado e reescrito de fontes confiáveis:
            </p>
            <ul className="space-y-1 text-sm text-slate-600">
              <li>Reuters</li>
              <li>CNBC</li>
              <li>Wall Street Journal</li>
              <li>Yahoo Finance</li>
              <li>MarketWatch</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-slate-200 text-center text-sm text-slate-500">
          <div className="flex justify-center gap-4 mb-4">
            <a href="/privacy" className="hover:text-emerald-900 transition-colors">Política de Privacidade</a>
            <span>|</span>
            <a href="/terms" className="hover:text-emerald-900 transition-colors">Termos de Serviço</a>
          </div>
          <p>© {new Date().getFullYear()} FinaNews. Todos os direitos reservados.</p>
          <p className="mt-2">Todo conteúdo é reescrito e adaptado para fins informativos.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;